import { ClientGet } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { Client } from "./interfaces";

export const makeClient = ({ connection, company }: ApiSliceParams) => {
    const {
        items: clients,
        allLoading: loading,
        listen,
    } = createListController<ClientGet, Client>({
        name: "client",
        connection,
        list: (con) => con.client.items({ company: company.value }),
    });

    const getByCode = (code: string) =>
        clients.value.find((c) => c.client === code);

    return { clients, loading, listen, getByCode };
};
